module.exports = __webpack_public_path__ + "img/um.3d347682.svg";